module.exports = __webpack_public_path__ + "img/icon_8.a969234f.png";